import React, { Fragment, useEffect, useState } from "react";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import {
    Button,
    Checkbox,
    Chip,
    colors,
    Container,
    CssBaseline,
    FormControlLabel,
    FormGroup,
    Hidden,
    makeStyles,
    Paper,
    Typography,
} from "@material-ui/core";
import { useTranslation } from "react-i18next";
import {
    useStylesAutoPurch
    , useStylesUiElemment,
    useStylesSpDial,
    useStylesLbl,
    useStylesAutoSafe,
} from '../../../../St/Reports/UseStyle';
import AddIcon from "@material-ui/icons/Add";

import CircularProgress from "@material-ui/core/CircularProgress";
import {
    useStylesUp,
    useStylesHed,
    useStylesAuto,
    useStylesTF,
    useStylesTD,
    useStylesBA,
    useStylesFU,
    useStylesCAB,
    SaleCheckbox,
    useStylesDSM,
    useStylesDPM,
    StyledMenuItem,
    StyledMenu,
    useStylesSN,
    SaleSwitch,
} from "../../../../St/comps/UseStyle";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import StopIcon from "@material-ui/icons/Stop";
import QuestionAnswer from "@material-ui/icons/Update";

const useStyles = makeStyles((theme) => ({
    root: {
        // backgroundColor: theme.palette.background.dark,
        minHeight: "100%",
        paddingBottom: theme.spacing(3),
    },
    itemW: {
        // display:'flex',
        width: "90%",
    },
    headerTitle: {
        // backgroundColor: colors.green[50],
        textAlign: "center",
        fontSize: 20,
        width: "100%",
        fontWeight: "bold"
    },
    headerTitle2: {
        backgroundColor: colors.green[50],
        textAlign: "center",
        fontSize: 20,
        width: "100%",
        direction: "rtl"
    },
    headerTitleP: {
        backgroundColor: colors.blue[50],
        textAlign: "center",
        fontSize: 20,
        width: "100%",
        direction: "rtl"
    },
    allWidth: {
        minWidth: 650,
    },
    checStyl: {
        marginTop: "17px",
        fontSize: "16px",
        padding: "-1px",
    },
    purchTotalCard: {
        backgroundColor: colors.blue[50],
        borderColor: colors.blue[300],
    },
}));

export default function InvoiceOilHead(props) {
    const {
        AutoOptions,
        isPurches,
        setting,
        changChckedYahm,
        checked,
        handleOpenCustomer,
        changAutoCustomers,
        optionsCustomers,
        changAutoType,
        valueType,
        infoInv,
        SaleCheckbox,
        valueCustomers,
        permiCuCo,
        getCustomerData,
        valueSafes,
        changAutoSafes,
    } = props;

    const { t } = useTranslation(["forms"]);

    const clasup = useStylesUp();
    const calsPurch = useStylesAutoPurch();
    const claslbls = useStylesLbl();
    const clasAo = useStylesAuto();
    const clasTF = useStylesTF();



    const clashd = useStylesHed();
    const clasSaf = useStylesAutoSafe();
    const clasBA = useStylesBA();
    const clasTD = useStylesTD();
    const clasui = useStylesUiElemment();
    const clasSp = useStylesSpDial();
    const classes = useStyles();


    const getoptionlbl2 = (option) => {

        return `${option.name + '-' + option.id}`
    };

    const getoptionlbl = (option) => {

        return `${option.id == null ? "ابحث عن رقم الصنف" : option.id}`
    };




    const headerTitle = {
        backgroundColor: "premary",
        textAlign: "center",
        fontSize: 20,
        width: "100%",
    }
    return (
        <div className={classes.root}>

            <Typography
                component="div"
                style={{ direction: "rtl" }}
            >

                <Grid item xs={12} container spacing={0} className={isPurches ? classes.headerTitleP : classes.headerTitle2}>
                    <Grid item lg={2} md={4} sm={4} xs={3}>
                        <FormControlLabel
                            id="costWithVat"
                            value="costWithVat"
                            name="costWithVat"
                            className={clashd.ckBoxHd} //disabled={true}
                            control={
                                <SaleCheckbox
                                    checked={checked.costWithVat}
                                    onChange={changChckedYahm}
                                    color="primary"
                                />
                            }
                            label={permiCuCo.CWVtxt}
                            labelPlacement="end"
                        />
                    </Grid>
                    {props.isDialog === true ? (
                        <Grid item lg={8} md={4} sm={4} xs={6}>
                            <Typography
                                size="small"
                                className={classes.headerTitle}
                                color="primary"
                            >
                                {/* {props.nameInv} */}
                                {"فاتورة بنزين"}

                            </Typography>
                        </Grid>
                    ) : (
                        <Grid item lg={8} md={4} sm={4} xs={6}>
                            <Typography
                                size="small"
                                className={classes.headerTitle}
                                color="primary"
                            >
                                {/* {setting.titleHed} */}
                                {AutoOptions?.permType?.id === 4 ? "فاتورة بنزين" : "فاتورة مبيعات"}

                            </Typography>
                        </Grid>
                    )}

                    <Grid item lg={2} md={4} sm={4} xs={3}></Grid>

                </Grid>

                <CssBaseline />
                <Container
                    component={Paper}
                    maxWidth={false}
                    style={{
                        padding: "10px",
                        paddingBottom: "0px",
                        borderBottomColor: colors.green[300],
                        borderBottomWidth: "1px",
                        borderBottomStyle: "solid",
                    }}
                >
                    <React.Fragment>
                        <Grid container style={{ padding: 5 }} spacing={1} >

                            <Grid
                                item

                                style={{
                                    paddingRight: "10px",
                                    color: colors.green[50],
                                    textAlign: "-webkit-center",
                                }}
                            >
                                <IconButton
                                    color="inherit"
                                    style={{
                                        background: colors.green[500],
                                        padding: "10px",
                                        color: "#fff",
                                    }}
                                    aria-label="open drawer"
                                    onClick={handleOpenCustomer}
                                >
                                    <AddIcon />
                                </IconButton>
                            </Grid>
                            <Grid item lg={3} md={2} sm={3} xs={8} style={{ paddingBottom: "0.5rem" }}>

                                <Autocomplete classes={clasAo}
                                    value={valueCustomers}
                                    onChange={(event, newValue) => {
                                        changAutoCustomers(newValue);
                                    }}
                                    id="combo-box-demo"
                                    size="small"
                                    options={optionsCustomers}
                                    getOptionLabel={(option) =>
                                        typeof option === "string" ? option : option.name
                                    }

                                    style={{}}
                                    // disabled={isHedden}
                                    disableClearable
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label={"العميل"}
                                            variant="outlined"
                                            InputLabelProps={{ className: claslbls.clrSale }}
                                        />
                                    )}

                                />
                            </Grid>

                            <Grid
                                item

                                style={{
                                    paddingRight: "2px",
                                    color: colors.green[50],
                                    textAlign: "-webkit-center",
                                }}
                            >
                                <IconButton
                                    color="inherit"
                                    style={{
                                        background: "#fff",
                                        padding: "5px",
                                        color: colors.green[900],
                                    }}
                                    aria-label="open drawer"
                                    onClick={() => {
                                        getCustomerData();
                                    }}
                                >
                                    <QuestionAnswer />
                                </IconButton>
                            </Grid>
                            <Grid item lg={2} md={2} sm={4} xs={6} style={{ paddingBottom: "0.5rem" }}>
                                <TextField fullWidth variant="outlined" size="small"
                                    id="id"
                                    label={t("invoice-id")}
                                    className={clasTF.rootSale}
                                    InputProps={{ className: claslbls.clrSale, readOnly: true }}
                                    InputLabelProps={{ className: claslbls.clrSale }}
                                    type="text"
                                    name="id" value={infoInv.id}
                                />
                            </Grid>


                            <Grid item lg={2} md={2} sm={3} xs={6} style={{ paddingBottom: "0.5rem" }}>
                                <Autocomplete
                                    classes={clasAo}
                                    value={valueType}
                                    onChange={(event, newValue) => {
                                        changAutoType(newValue);
                                    }}
                                    id="controllable-states-demo"
                                    size="small"
                                    options={AutoOptions.types}
                                    getOptionLabel={(option) =>
                                        typeof option === "string" ? option : option.name
                                    }
                                    disableClearable
                                    renderInput={(params) => (
                                        <TextField
                                            id="typeinvs"
                                            {...params}
                                            label={t("invoice-type")}
                                            variant="outlined"
                                            size="small"
                                            InputLabelProps={{ className: claslbls.clrBlackLblS }}
                                        />
                                    )}
                                />

                            </Grid>
                            <Hidden mdDown={["sm"]}>

                                <Grid item lg={2} md={2} sm={3} xs={4} style={{ paddingBottom: "0.5rem" }}>
                                    <Autocomplete classes={clasAo}
                                        value={valueSafes}
                                        onChange={(event, newValue) => {
                                            changAutoSafes(newValue);
                                        }}
                                        id="combo-box-demo"
                                        size="small"
                                        options={AutoOptions.Safes}
                                        getOptionLabel={(option) =>
                                            typeof option === "string" ? option : option.name
                                        }

                                        style={{}}
                                        disableClearable
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label={t("safe")}
                                                variant="outlined"
                                                InputLabelProps={{ className: claslbls.clrBlackLblSal }}
                                            />
                                        )}

                                    />
                                </Grid>
                            </Hidden>

                        </Grid>
                    </React.Fragment>
                </Container>
                <CssBaseline />
            </Typography>

        </div>
    );
}
